export default __webpack_public_path__ + "static/media/sidebar-icon-1.22318b48.svg";